import { ReactNode } from 'react';
import {
  StackLayout,
  HeadingText,
  ParagraphText,
  TextAction,
  Divider,
} from '@leagueplatform/genesis-core';
import { useIntl, FormattedMessage } from '@leagueplatform/locales';

const ContentSection = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => (
  <StackLayout orientation="vertical" spacing="$one">
    <HeadingText level="2" size="xl" css={{ typography: '$headingTwo' }}>
      {title}
    </HeadingText>
    {children}
  </StackLayout>
);

export const MyHealthContactUsContent = () => {
  const { formatMessage } = useIntl();
  const email = formatMessage({ id: 'STR_CONTACT_US_EMAIL' });

  return (
    <>
      <ContentSection
        title={formatMessage({ id: 'STR_CONTACT_US_ABOUT_TITLE' })}
      >
        <ParagraphText>
          {formatMessage({ id: 'STR_CONTACT_US_BODY' })}
        </ParagraphText>
      </ContentSection>
      <Divider />
      <ContentSection title={formatMessage({ id: 'STR_CONTACT_US_TITLE' })}>
        <ParagraphText>
          <FormattedMessage
            id="STR_CONTACT_US_EMAIL_BODY"
            values={{
              emailLink: (
                <TextAction href={`mailto:${email}`}>{email}</TextAction>
              ),
            }}
          />
        </ParagraphText>
        <ParagraphText>
          {formatMessage({ id: 'STR_CONTACT_US_FOOTER_NOTE' })}
        </ParagraphText>
      </ContentSection>
    </>
  );
};
